import useChatStore from 'Components/Chat/store';
import ContentMessage from 'Components/Common/Markdown/ContentMessage';
import Skeleton from 'utils/Skeleton';
import ModelProviderError from './ModelProviderError';
import { MediaLoadingSkeleton } from '@/Components/Common/Markdown/MediaComponents';

const ContentMessageLoader = ({ message, loading, modelsIds }) => {
  const isModelProviderError = useChatStore(
    (state) => state.isModelProviderError
  );

  return (
    <>
      {isModelProviderError(message) ? (
        <ModelProviderError item={message} modelsIds={modelsIds} />
      ) : (
        <>
          <ContentMessage
            message={message?.data?.content ?? ''}
            messageId={message._id}
            userType={message?.data?.role}
            originalPrompt={message?.data?.originalPrompt}
            videos={message.videoURL}
            audios={message.audioURL}
            images={message?.imagesURL}
            isEditable={false}
            loading={loading}
            functionCapability={message?.data?.function}
            reasoning={message?.data?.reasoning}
            annotations={message?.data?.annotations}
          />
          <div className='flex gap-2'>
            {message?.imagesURL?.length > 0 && <>{message.imagesURL.map((image) => <MediaLoadingSkeleton />)}</>}
          </div>
          {message?.videoURL && <MediaLoadingSkeleton />}
          {message.finished === false && !message.videoURL && !message.audioURL && !message?.imagesURL?.length && <Skeleton />}
          {message?.audioURL && <div className="h-8 min-w-[200px] max-w-[350px] rounded-full bg-gray-200 animate-pulse mx-auto mt-2" />}
        </>
      )}
    </>
  );
};

export default ContentMessageLoader;
